<template>
  <transition name="fade">
    <div class="gk-loading" v-if="visible">
      <svg class="gk-loading-spinner" :style="styles" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="gk-loading-path" :class="[colorClass]" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
      <p class="label" v-if="label">{{label}}</p>
    </div>
  </transition>
</template>

<script>
import LoadingCtrl from './config'

export default {
  name: 'gk-loading',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '40px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data () {
    return {}
  },
  computed: {
    colorClass () {
      return LoadingCtrl.getColor(this.color) || ''
    },
    styles () {
      return {
        width: this.size,
        height: this.size
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
